import common from '../module/common';

class FormErrorConstants {
    constructor(selector) {
        this.constants = {
            auth_login: "Sorry, we could not log you in. Please, enter your account details.",
            email_invalid: "The e-mail address is not correct",
            captcha_is_required: "Captcha gegevens onjuist",
            email_exist: `
            Oops, we've already discovered the email address you entered in our system.
            Maybe you have already started to set up an account in the past or subscribed to our newsletter.
            In order to assign your email address clearly to your individual account, we recommend that you log in or request a new password.
            If you have questions, please don't hesitate to <a href="https://www.futurum.cc/contact-page">contact</a> us.`,
            user_name: "Please enter your first name",
            user_lastname: "Please enter your last name",
            last_name: "Please enter your last name",
            zip: "Please enter your zip code",
            nbr: "Please enter your house number",
            street: "Please enter your street",
            city: "Please enter your city",
            country: "Please choose your country instead of Land niet juist. This field is required",
            phone: "Please enter your telephone",
            email: "Please enter valid e-mail address",
            description: "Please enter your display name",
            passworderror: "Password does not match",
            payment_ideal_not_set_child: "Kies svp met welke bank je jouw ideal betaling wilt doen",
            payment_adyen_error: "Please fill all fields",
            payment_creditcard_not_set_child: "Please choose your credit card",
            nodeliverypoint: "Je dient nog een afhaalpunt te selecteren",
            nopaymentmehod: "Please choose a payment method",
            retour_quantity_is_greater: "Quantity of items is more than you ordered",
            retour_quantity_number: "Please enter quantity",
            field_required: "This field is required",
            minlength: "Minimaal: {1} tekens lang",
            message_required: "Please enter a personal message",
            regid: "Email address is not correct.",
            newpassworderror: "Password should contain eight characters with at least one number and one special character",
            retour_excahnge_is_required: "Please enter a subject",
            clang_newsletter_subscription_failed: "Het opgegeven emailadres is niet correct. Probeer het opnieuw.",
            clang_newsletter_subscription_successful: "Je bent succesvol ingeschreven voor onze nieuwsbrief",
            wishlist_email_success : 'Your message was sent successfully',
            wishlist_email_error: 'If not sent: Your message was not sent',
            nodeliverypoint_form: 'Please choose a shipping method',
            sex: "Please enter your gender",
            question: "Please fill in at least five characters",
            latin: "USE ONLY LATIN LETTERS",
        };

        if (selector) {
            this.forms = $(selector);
        } else {
            this.forms = $('form.validate');
        }
    }

    formatString() {
        let args = [].slice.call(arguments);
        if (this.toString() !== '[object Object]') {
            args.unshift(this.toString());
        }

        let pattern = new RegExp('{([1-' + args.length + '])}','g');

        return String(args[0]).replace(pattern, function(match, index) {
            return args[index];
        });
    }

    init() {
        for (let i=0; i < this.forms.length; i++) {
            let currentForm = $(this.forms[i]);
            let foundErrorElements = currentForm.find('[data-error]');

            for (let j = 0; j < foundErrorElements.length; j++) {
                let wrapFoundElement = $(foundErrorElements[j]);
                if (!wrapFoundElement.parent().next().hasClass('notice-error')) {
                    let messageConstant = wrapFoundElement.attr('data-error');
                    let message = this.constants.hasOwnProperty(messageConstant) ? this.constants[messageConstant] : messageConstant;
                    wrapFoundElement.parents('.column').removeClass('valid');
                    wrapFoundElement.parents('.column').addClass('error');
                    if (wrapFoundElement.attr('data-minlength')) {
                        message = this.formatString(message, wrapFoundElement.attr('data-minlength'))
                    }
                    wrapFoundElement.parent().after(this.getNoticeErrorHtml(message));
                    this.scrollToTopErrorContainer();
                }
            }
        }

        $(":input").change(event => {
            const $current = $(event.target);
            const $el = $current.closest('.column');
            const $elAfter = $current.parent();
            let $errorDiv = $(event.target.parentElement.parentElement).find(".notice-error");

            if ($errorDiv.length) {
              this.hideNoticeErrorNext($el, $elAfter)
              $errorDiv.remove();
            }

            if ($current.attr('required')){
              if (!$current.val().trim().length) {
                this.showNoticeErrorAfter($el, $elAfter, this.constants[$current.data('error-message')])
                return;
              }
            }

            if ($current.attr('latin') && this.hasLatinSymbols($current)) {
                this.showNoticeErrorAfter($el, $elAfter, this.constants.latin)
                return;
            }
        });

        let errorContainer = $('.notice-custom-error, .notice-error').first();
        if (errorContainer.length) {
            let errorInput = errorContainer.closest('.column');
            if (errorInput.length) {
                common.scrollToAnchor(errorInput);
            }
        }
    }

    scrollToTopErrorContainer() {
        let errorContainer = $('.notice-error').first();
        if (errorContainer.length) {
           common.scrollToAnchor(errorContainer);
        }
    }

    hasLatinSymbols(el) {
      const rforeign = /[^\u0000-\u007f]/;
      let foreignCharacters = el.val();
      return rforeign.test(foreignCharacters);
    }

   getNoticeErrorHtml(message) {
        return message ?
          `<div class="notice notice-error">
              <div class="icon"><img src="/svg/icon-error.svg" alt=""></div>
              <div class="text">${message}</div>
          </div>`: '';
    }

    showNoticeErrorAfter (element, elementAfter, message) {
        $(element).removeClass('valid');
        $(element).addClass('error');
        $(elementAfter).after(this.getNoticeErrorHtml(message))
    }

    hideNoticeErrorNext(element, noticeError) {
        $(element).removeClass('error');
        $(noticeError).next('.notice-error').remove();
        $(element).addClass('valid');
    }

    /**
     *
     * @param collection
     * @returns {boolean}
     */
    validateInputElementCollection(collection) {
        let checkValidation = true;
        collection.each(function (index, element) {
            let _element = $(element);
            let parent = _element.parent();

            if (_element.is('input')) {
                checkValidation = false;
                if (_element.is(':checked')) {
                    checkValidation = true;
                    return false;
                }
            }

            if (_element.is('text')) {
                if (_element.val().length  === 0) {
                    checkValidation = false;
                    return false;
                }
            }
        });

        return checkValidation;
    }

    removeErrors(form) {
        form.find('.notice-error').remove();
    }

    removeDataError(form) {
        form.find('input[data-error]').each(function (i, element) {
            $(element).removeAttr('data-error');
        })
    }
}

export default FormErrorConstants;
